import { HttpError } from '@refinedev/core';
import axios from 'axios';

const baseAxiosInstance = axios.create({
  timeout: 35000, // 35 seconds
});

baseAxiosInstance.interceptors.response.use(
  (response: any) => {
    return response;
  },
  (error) => {
    const customError: HttpError = {
      ...error,
      message: error.response?.data?.message ?? error.message,
      statusCode: error.response?.status ?? error?.code,
    };

    return Promise.reject(customError);
  }
);

export { baseAxiosInstance };
